<div class="left">
  <span class="id">{{ index }}</span>
  <span class="node" [ngClass]="baza.perEksport ? 'miratuar':'paMiratuar'" *ngIf="baza.nyjaId">{{ baza.nyjaId | nyja:
    'long' }} </span>
  <span class="title" [ngClass]="baza.perEksport ? 'miratuar':'paMiratuar'">{{ baza.fjala }}</span>
  <span class="homonym" [ngClass]="baza.perEksport ? 'miratuar':'paMiratuar'" *ngIf="baza.homonimi">{{ baza.homonimi |
    romanNumber }}</span>
  <span class="partOfSpeech" *ngIf="baza.pjesaLigjeratesId">
    <span class="pSpeech">{{ baza | partOfSpeech }}</span>
  </span>
</div>
<div class="right">
  <div class="icons" [class.w-md]="baza.nrKomenteve > 0" [class.w-sm]="baza.nrFjaleveTePerzgjedhura > 0">
    <span class="approvals primary-color" *ngIf="baza.nrFjaleveTePerzgjedhura > 0">
      <mat-icon>check</mat-icon>
      <span class="number">{{ baza.nrFjaleveTePerzgjedhura }}</span>
    </span>
    <span class="comment primary-color" *ngIf="baza.nrKomenteve > 0" customToolTip classList="word-list-comments"
      [contentTemplate]="template" originX="end" originY="center" overlayX="start" overlayY="center" [offsetY]="0"
      [horizontalAnim]="'left'" (mouseenter)="mouseenter()" (mouseleave)="mouseleave()">
      <mat-icon svgIcon="as_comments"></mat-icon>
    </span>
  </div>
</div>

<ng-template #template>
  <div class="comments">
    <div class="items" *ngIf="komentetGroup && komentetGroup.length > 0; else loading">
      <div class="group" *ngFor="let komentiGroup of komentetGroup">
        <div class="item" [class.self]="userId == komenti.regjistruarOperatoriId"
          *ngFor="let komenti of komentiGroup.komentet; let i = index">
          <span class="operatori">{{ komenti.regjistruarOperatori }}</span>
          <div class="pershkrimi-wrap">
            <span class="pershkrimi" matTooltipShowDelay="500"
              [matTooltip]="(komenti.dataRegjistrimit | date: 'dd.MM.yyyy - H:mm')!"
              [matTooltipPosition]="userId == komenti.regjistruarOperatoriId ? 'before' : 'after'">{{ komenti.pershkrimi
              }}</span>
          </div>
        </div>
      </div>
    </div>
    <ng-template #loading>
      <mat-spinner [diameter]="20"></mat-spinner>
    </ng-template>
  </div>
</ng-template>